/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { GregorianCalendar } from '@internationalized/date';

export function createCalendar(identifier: string) {
    switch (identifier) {
        case 'gregory':
            return new GregorianCalendar();
        default:
            throw new Error(`Unsupported calendar ${identifier}`);
    }
}
